import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useAuth } from '../MsalProvider';
import { useMsal } from '@azure/msal-react';

const StyledControls = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;

  * {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  div {
    padding: 0 15px;
  }
  a {
    background: #5eb2ff;
    padding: 0 10px;
    min-width: 80px;
    color: #fff;
    text-decoration: none;
    cursor: pointer;
  }
  a:hover {
    text-decoration: underline;
  }
`;

type LoginBoxProps = WithTranslation;

// User is always authenticated when this component renders (guaranteed by MsalAuthenticationTemplate)
const LoginBox: React.FC<LoginBoxProps> = ({ t }) => {
  const { userName } = useAuth();
  const { instance } = useMsal();

  const handleLogout = () => {
    instance.logoutRedirect();
  };

  return (
    <StyledControls>
      <>
        {userName && <div>{userName}</div>}
        <a onClick={handleLogout}>
          {`${t('log_out')} ⇨`}
        </a>
      </>
    </StyledControls>
  );
};

export default withTranslation()(LoginBox);